import TutorialIntro from "../../../common/TutorialIntro";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const TutorialLogic = ({
    title,
    link,
    isActive,
    startTutorial,
    setTutorialExitCallback,
}) => {
    const { t } = useTranslation("menu");

    // default
    let displayComponent = (
        <li key={link}>
            <Link to={link} className={isActive ? "activeLi" : "inactiveLi"}>
                {title}
            </Link>
        </li>
    );

    // settings page
    if (title === t("titleBrowserSource")) {
        displayComponent = (
            <TutorialIntro
                text={t("tutorialHereBrowserSource")}
                startTutorial={startTutorial}
                setTutorialExitCallback={setTutorialExitCallback}
                content={
                    title ? (
                        <li key={link}>
                            <Link
                                to={link}
                                className={isActive ? "activeLi" : "inactiveLi"}
                            >
                                {title}
                            </Link>
                        </li>
                    ) : (
                        <></>
                    )
                }
                location="settings"
            />
        );
    }

    if (title === t("titleGeneralSettings")) {
        displayComponent = (
            <TutorialIntro
                text={t("tutorialHereMemesWillBeVisibale")}
                startTutorial={startTutorial}
                setTutorialExitCallback={setTutorialExitCallback}
                content={
                    title ? (
                        <li key={link}>
                            <Link
                                to={link}
                                className={isActive ? "activeLi" : "inactiveLi"}
                            >
                                {title}
                            </Link>
                        </li>
                    ) : (
                        <></>
                    )
                }
                location="settings"
            />
        );
    }

    if (title === t("titleAccountSettings")) {
        displayComponent = (
            <TutorialIntro
                text={t("tutorialHereAreAccountSettings")}
                startTutorial={startTutorial}
                setTutorialExitCallback={setTutorialExitCallback}
                content={
                    title ? (
                        <li key={link}>
                            <Link
                                to={link}
                                className={isActive ? "activeLi" : "inactiveLi"}
                            >
                                {title}
                            </Link>
                        </li>
                    ) : (
                        <></>
                    )
                }
                location="settings"
            />
        );
    }

    // Meme Library
    if (title === t("titleTemplates")) {
        displayComponent = (
            <TutorialIntro
                text={t("tutorialHereSeachSelection")}
                startTutorial={startTutorial}
                setTutorialExitCallback={setTutorialExitCallback}
                content={
                    title ? (
                        <li key={link}>
                            <Link
                                to={link}
                                className={isActive ? "activeLi" : "inactiveLi"}
                            >
                                {title}
                            </Link>
                        </li>
                    ) : (
                        <></>
                    )
                }
                location="browse"
            />
        );
    }
    if (title === t("titleSelected")) {
        displayComponent = (
            <TutorialIntro
                text={t("tutorialHereViewSelectedMemes")}
                startTutorial={startTutorial}
                setTutorialExitCallback={setTutorialExitCallback}
                content={
                    title ? (
                        <li key={link}>
                            <Link
                                to={link}
                                className={isActive ? "activeLi" : "inactiveLi"}
                            >
                                {title}
                            </Link>
                        </li>
                    ) : (
                        <></>
                    )
                }
                location="browse"
            />
        );
    }
    if (title === t("titleUpload")) {
        displayComponent = (
            <TutorialIntro
                text={t("tutorialIfYouHaveYourOwnImages")}
                startTutorial={startTutorial}
                setTutorialExitCallback={setTutorialExitCallback}
                content={
                    title ? (
                        <li key={link}>
                            <Link
                                to={link}
                                className={isActive ? "activeLi" : "inactiveLi"}
                            >
                                {title}
                            </Link>
                        </li>
                    ) : (
                        <></>
                    )
                }
                location="browse"
            />
        );
    }

    return displayComponent;
};

export default TutorialLogic;
